import { appActions } from "store/slices/app";

let tokenCheckInterval: number | undefined;

const TOKEN_EXPIRY_DURATION =
  process.env.NODE_ENV === "development"
    ? 3 * 60 * 60 * 1000 // 3 seconds for testing 3 * 1000
    : 3 * 60 * 60 * 1000; // 3 hours for production

const TOKEN_CHECK_INTERVAL = 5 * 1000; // Check every 5 seconds

export const setAuthToken = (token: string) => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("authTokenExpiry");

  localStorage.setItem("authToken", token);
  const expiryTime = Date.now() + TOKEN_EXPIRY_DURATION;
  localStorage.setItem("authTokenExpiry", expiryTime.toString());

  startTokenCheck();
};

export const clearAuthToken = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("authTokenExpiry");
  localStorage.removeItem("appData");

  if (tokenCheckInterval) {
    clearInterval(tokenCheckInterval);
    tokenCheckInterval = undefined;
  }
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem("authToken");
};

export const checkTokenExpiry = (): boolean => {
  const expiryTime = localStorage.getItem("authTokenExpiry");
  if (!expiryTime) return true;

  return Date.now() > parseInt(expiryTime, 10);
};

const startTokenCheck = () => {
  if (tokenCheckInterval) {
    clearInterval(tokenCheckInterval);
  }

  tokenCheckInterval = window.setInterval(() => {
    if (checkTokenExpiry()) {
      clearAuthToken();
      window.dispatchEvent(new CustomEvent("authTokenExpired"));
    }
  }, TOKEN_CHECK_INTERVAL);

  if (checkTokenExpiry()) {
    clearAuthToken();
    window.dispatchEvent(new CustomEvent("authTokenExpired"));
  }
};

export const logout = (dispatch: any) => {
  clearAuthToken();
  dispatch(appActions.clearAppData());
  window.location.href = "/login";
  window.location.reload();
};

if (getAuthToken()) {
  startTokenCheck();
}
